import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './banner.module.scss';

export type BannerVariant = 'error' | 'warning' | 'info';

type Props = {
  children: ReactNode;
  variant?: BannerVariant;
  className?: string;
  'data-testid'?: string;
};

export function Banner( { children, variant = 'info', className, 'data-testid': dataTestId }: Props ) {
  return (
    <div
      className={ clsx( styles.banner, styles[`banner--${ variant }`], className ) }
      role="status"
      data-testid={ dataTestId }
    >
      <p className={ styles.body }>{ children }</p>
    </div>
  );
}
